import {
  Avatar,
  Badge,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  FormControlLabel,
  Grid2,
  Paper,
  Slider,
  Switch,
  Tab,
  Tabs,
  TextField,
  Typography,
  Alert,
  Snackbar,
  SlideProps,
  Slide,
} from "@mui/material";
import "./UserProfile.scss";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import AccountCircleTwoToneIcon from "@mui/icons-material/AccountCircleTwoTone";
import NotificationsNoneTwoToneIcon from "@mui/icons-material/NotificationsNoneTwoTone";
import ImageIcon from "@mui/icons-material/Image";
import CropIcon from "@mui/icons-material/Crop";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import SettingsTwoToneIcon from "@mui/icons-material/SettingsTwoTone";
import React, { useCallback, useEffect, useRef, useState } from "react";
import Cropper from "react-easy-crop";
import getCroppedImg from "../../lib/cropImage";
import { useUser } from "../../context/UserContext";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import PasswordComponent, { PasswordComponentRef } from "../signin/PasswordComponent";
import { useMenu } from "../../context/MenuContext";
import { LOCALSTORAGENAME, PASSWORDCHANGEMODE, REGEX, SIGNINRESPONSES } from "../../data/constants";
import {
  USER_PROFILE_TEXT,
  USERSIGNINMESSAGES,
  USERSIGNUPMESSAGES,
} from "../../constants/messages";
import useApi from "../../hooks/useApi";
import { toDisplayDateOrNull } from "../../utils/dateHelper";
import {
  UserProfileDto,
  ResetPasswordDto,
  SaveProfileDto,
  SaveNFDto,
  VerifyCurrentPasswordDto,
  VerifyCurrentPasswordResultDto,
} from "../../types/User";
import {
  getUserProfileInfo,
  resetPassword,
  verifyCurrentPassword,
  getAccountInfo,
  saveUserProfileInfo,
  saveNotificationPreferences,
  saveProfilePhoto,
  removeProfilePhoto,
  getEmployeeProfileImage,
  checkUsernameExist,
} from "../../services/userService";

import BackdropProgressBar from "../../components/ui/BackdropProgressBar";
import ConfirmationDialog from "../../components/ui/ConfirmationDialog";
import { shouldUseEmployeePhotoFallback } from "../../utils/commonHelper";
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

type PasswordComplexityRequirementsResult = {
  U?: boolean;
  L?: boolean;
  N?: boolean;
  S?: boolean;
  Length?: boolean;
  UserDetailsContains?: boolean;
  BlackList?: boolean;
  ProhibitedChars?: boolean;
};

const NOTIFICATION_FLAGS = {
  SMS: 1,
  EMAIL: 2,
  IN_APP: 4,
};

const hasEmailEditPermission = false; // or from API
const hasPhoneEditPermission = false; // or from API
const hasActiveUntilPermission = false; // or from API
const hasFirstNameEditPermission = false; // or from API
const hasLastNameEditPermission = false; // or from API
const hasRoleEditPermission = false; // or from API
const updateState = <T extends Record<string, unknown>>(
  setState: React.Dispatch<React.SetStateAction<T>>,
) => {
  return (newState: Partial<T>) => {
    setState((prevState) => ({
      ...prevState,
      ...newState,
    }));
  };
};

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ padding: "0px 0px 0px 0px" }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function UserProfile() {
  const { loading, executeApi } = useApi();
  const { userId, firstName, lastName, setProfileImage, setUserName, setFirstName, setLastName } =
    useUser();
  // All roles assigned to the logged-in user, comma-separated (set in localStorage at sign-in).
  const rolesList = (localStorage.getItem(LOCALSTORAGENAME.ROLENAMES) || "")
    .split(",")
    .map((role) => role.trim())
    .filter(Boolean);
  const [formData, setFormData] = useState({
    username: "",
    email: "",
    firstName: "",
    lastName: "",
    phone: "",
    activeUntil: null,
  });
  const [userNameError, setUserNameError] = useState<boolean>(false);
  const [userNameErrorMessage, setUserNameErrorMessage] = useState<string>("");
  const [reusePasswordError, setReusePasswordError] = useState<string | null>(null);
  const [currentPasswordError, setCurrentPasswordError] = useState<boolean>(false);
  // Bug 80058: the New/Confirm fields stay hidden until the current password is verified server-side.
  const [isCurrentPasswordVerified, setIsCurrentPasswordVerified] = useState<boolean>(false);
  const SlideUp = (props: SlideProps) => <Slide {...props} direction="up" />;
  const [lastPasswordOn, setLastPasswordOn] = useState<string>("");
  const [notificationPrefs, setNotificationPrefs] = useState({
    sms: false,
    email: false,
    inApp: false,
  });

  const [originalNotificationPrefs, setOriginalNotificationPrefs] = useState({
    sms: false,
    email: false,
    inApp: false,
  });

  const [value, setValue] = React.useState(0);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const initialState = {
    description: "",
    //rolePermissions: [] as RoleFolderPermissionDto[],
    file: null as File | null,
    validationError: null as string | null,
    dialogOpen: false,
    isInitialLoad: true,
    displayNotification: false,
  };
  const [profileState, setProfileState] = useState(initialState);
  const updateProfileState = useCallback((newState: Partial<typeof profileState>) => {
    setProfileState((prevState) => ({
      ...prevState,
      ...newState,
    }));
  }, []);
  const handleSnackbarClose = () => setSnackbarPassResetMsgOpen(false);
  const handleProfileSnackbarClose = () => setSnackbarProfileSaveOpen(false);

  const [passwordData, setPasswordData] = useState({
    password: "",
    newPassword: "",
    confirmPassword: "",
    showPassword: false,
    showConfirmPassword: false,
    validationResults: {} as PasswordComplexityRequirementsResult,
  });
  const updatePasswordDataState = updateState<typeof passwordData>(setPasswordData);

  const cancelPersonalInfoChanges = () => {
    setFormData((prev) => ({
      ...prev,
      username: originalUserName,
    }));
  };

  const cancelNotificationChanges = () => {
    setNotificationPrefs(originalNotificationPrefs);
  };

  const cancelAccountSettingsChanges = () => {
    setPasswordData({
      password: "",
      newPassword: "",
      confirmPassword: "",
      showPassword: false,
      showConfirmPassword: false,
      validationResults: {} as PasswordComplexityRequirementsResult,
    });
    passwordRef.current?.reset();
    setReusePasswordError(null);
    setCurrentPasswordError(false);
    setIsCurrentPasswordVerified(false);
    setTimeout(() => {
      currentPasswordRef.current?.focus();
    }, 0);
  };

  const savePersonalInfo = async () => {
    // Validate username before saving
    if (formData.username && formData.username.trim() !== "") {
      if (!validateUserNameField(formData.username)) {
        return; // Stop save if validation fails
      }
      const isUserNameExist = await executeApi<string, boolean>(
        checkUsernameExist,
        formData.username.trim(),
      );
      if (isUserNameExist) {
        setUserNameError(true);
        setUserNameErrorMessage(USERSIGNUPMESSAGES.USERNAME_ALREADY_TAKEN);
        return;
      }
    }

    const payload: SaveProfileDto = {
      userId: userId,
      userName: formData.username?.trim() || null,
    };

    try {
      await executeApi<SaveProfileDto, string>(saveUserProfileInfo, payload);

      setSnackbarProfileSaveOpen(true);
      setOriginalUserName(formData.username);
      // Blank username: clear context so Header getUserDisplayName shows first + last.
      setUserName(formData.username?.trim() || null);
      if (formData.firstName) {
        setFirstName(formData.firstName);
      }
      if (formData.lastName) {
        setLastName(formData.lastName);
      }
    } catch (error) {
      console.error(USERSIGNINMESSAGES.PERSONALINFO_FAILED_ALERT, error);
    }
  };

  const saveAccountSettings = async () => {
    await verifyAndSave(); // existing password logic
  };

  const renderSwitchRow = (
    label: string,
    description: string,
    checked: boolean,
    onChange: (checked: boolean) => void,
  ) => (
    <Grid2 container justifyContent="space-between" alignItems="flex-start" sx={{ mb: 3 }}>
      <Grid2 size={{ xs: 12, md: 10 }}>
        <Typography fontSize={14} fontWeight="600" mb={0.5}>
          {label}
        </Typography>
        <Typography fontSize={12} color="text.secondary">
          {description}
        </Typography>
      </Grid2>
      <Grid2
        size={{ xs: 12, md: 2 }}
        display="flex"
        sx={{ justifyContent: { xs: "flex-start", md: "flex-end" } }}
      >
        <FormControlLabel
          control={
            <Switch size="small" checked={checked} onChange={(e) => onChange(e.target.checked)} />
          }
          label=""
        />
      </Grid2>
    </Grid2>
  );

  //image crop
  const [imageSrc, setImageSrc] = useState("");
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [open, setOpen] = useState(false);
  const [removePhotoConfirmOpen, setRemovePhotoConfirmOpen] = useState<boolean>(false);
  const [snackbarPhotoRemovedOpen, setSnackbarPhotoRemovedOpen] = useState<boolean>(false);
  const avatarUploadRef = useRef<HTMLInputElement>(null);

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedImage(URL.createObjectURL(file));
      setOpen(true);
    }
  };

  const onCropComplete = useCallback((_, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleCropSave = async () => {
    const croppedImage = await getCroppedImg(selectedImage, croppedAreaPixels);
    setImageSrc(croppedImage);
    setOpen(false);
    // Convert base64 → File

    const response = await fetch(croppedImage);
    const blob = await response.blob();

    const file = new File([blob], "profile.jpg", { type: blob.type });

    // store file in state (IMPORTANT)
    updateProfileState({ file: file });

    // call API immediately OR later on save
    await createFile(file);
  };
  const createFile = async (file?: File) => {
    const uploadFile = file || profileState.file;

    if (!uploadFile) return;

    const formData = new FormData();
    formData.append("portalFileDto.description", uploadFile.name.trim());
    formData.append("portalFileDto.file", uploadFile);
    formData.append("portalFileDto.userId", String(userId ?? 0));

    const profilePhotoUrl = await executeApi<FormData, string>(saveProfilePhoto, formData);

    if (profilePhotoUrl) {
      setProfileImage(profilePhotoUrl);
    }
  };

  // Bug 79975: clears the uploaded photo so the card and header avatars fall back to the initials
  // avatar. The file input is reset too, otherwise re-picking the same file fires no change event.
  const handleRemovePhotoConfirm = async (confirmed: boolean) => {
    setRemovePhotoConfirmOpen(false);
    if (!confirmed) return;

    const removed = await executeApi<number, boolean>(removeProfilePhoto, userId);
    if (!removed) return;

    setImageSrc("");
    setSelectedImage(null);
    setProfileImage(null);
    updateProfileState({ file: null });
    if (avatarUploadRef.current) {
      avatarUploadRef.current.value = "";
    }
    setSnackbarPhotoRemovedOpen(true);
  };

  const [originalUserName, setOriginalUserName] = useState<string>("");

  const validateUserNameField = (username: string) => {
    let isValid = true;
    if (!username || username.trim() === "") {
      isValid = true;
      setUserNameError(false);
      setUserNameErrorMessage("");
    } else if (!REGEX.USERNAME.test(username)) {
      setUserNameError(true);
      setUserNameErrorMessage(USERSIGNUPMESSAGES.USERNAME_CAN_ONLY_CONTAIN);
      isValid = false;
    } else {
      setUserNameError(false);
      setUserNameErrorMessage("");
      isValid = true;
    }
    return isValid;
  };

  const handleUserNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newUsername = event.target.value;
    setFormData({ ...formData, username: newUsername });
    if (newUsername.length === 0) {
      setUserNameError(false);
      setUserNameErrorMessage("");
    } else {
      validateUserNameField(newUsername);
    }
  };

  const handleUserNameBlur = () => {
    if (formData.username.trim() !== "") {
      validateUserNameField(formData.username);
    }
  };

  function stringAvatar(firstName?: string, lastName?: string, userName?: string) {
    let name = "";

    if (firstName || lastName) {
      name = `${firstName ?? ""} ${lastName ?? ""}`.trim();
    } else if (userName) {
      name = userName;
    }

    if (!name) return { children: "" };

    const words = name.split(/\s+/);

    const firstInitial = words[0]?.[0] || "";
    const secondInitial = words[1]?.[0] || "";

    return {
      children: `${firstInitial}${secondInitial}`.toUpperCase(),
    };
  }
  const passwordRef = useRef<PasswordComponentRef>(null);
  const currentPasswordRef = useRef<HTMLInputElement>(null);

  const handlePasswordChange = (value: string) => {
    updatePasswordDataState({ newPassword: value });
  };

  const handleConfirmPasswordChange = (value: string) => {
    updatePasswordDataState({ confirmPassword: value });
  };

  const handleChildComponentToValidatePassword = () => {
    if (passwordRef.current) {
      return passwordRef.current.childComponetCall();
    }
    return true;
  };
  const handleOldPasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    updatePasswordDataState({ password: e.target.value });
    if (e.target.value) setCurrentPasswordError(false);
    // Editing the current password invalidates a previous verification - re-hide New/Confirm so the
    // user cannot verify one password and then submit the change against a different one.
    setIsCurrentPasswordVerified(false);
    setReusePasswordError(null);
  };

  const handleVerifyCurrentPassword = async () => {
    if (!passwordData.password) {
      setCurrentPasswordError(true);
      currentPasswordRef.current?.focus();
      return;
    }

    const result = await executeApi<VerifyCurrentPasswordDto, VerifyCurrentPasswordResultDto>(
      verifyCurrentPassword,
      { userId: userId, currentPassword: passwordData.password },
    );

    if (!result) return;

    if (result.isLocked) {
      setIsCurrentPasswordVerified(false);
      setReusePasswordError(USERSIGNINMESSAGES.ACCOUNT_LOCKED_MESSAGE);
      return;
    }

    if (!result.isVerified) {
      setIsCurrentPasswordVerified(false);
      setReusePasswordError(USERSIGNINMESSAGES.NOMATCH_PASSWORD_ALERT);
      currentPasswordRef.current?.focus();
      return;
    }

    setReusePasswordError(null);
    setIsCurrentPasswordVerified(true);
  };
  //const handleConfirmPasswordChange = () => {};
  const { permissions } = useMenu();

  const UserProfileInfo = useCallback(async () => {
    const res = await executeApi<number, UserProfileDto>(getUserProfileInfo, userId);
    if (!res) {
      return;
    }

    setFormData({
      username: res.userName ?? "",
      email: res.cachedEmailAddress ?? "",
      firstName: res.cachedFirstName ?? "",
      lastName: res.cachedLastName ?? "",
      phone: res.cachedPhoneNumber ?? "",
      activeUntil: toDisplayDateOrNull(res.activeUntil),
    });
    if (res.profileImage) {
      setImageSrc(res.profileImage);
      setProfileImage(res.profileImage);
    } else if (shouldUseEmployeePhotoFallback(res.profileImage)) {
      const empProfileImg = await executeApi<number, string>(getEmployeeProfileImage, userId);
      if (empProfileImg) {
        setImageSrc(empProfileImg);
        setProfileImage(empProfileImg);
      }
    } else {
      // Photo explicitly removed (Bug 79975) - keep the initials avatar, no HR photo fallback.
      setImageSrc("");
      setProfileImage(null);
    }
    setOriginalUserName(res.userName || "");
    if (res.cachedFirstName) {
      setFirstName(res.cachedFirstName);
    }
    if (res.cachedLastName) {
      setLastName(res.cachedLastName);
    }
    // Empty username: leave context userName as-is until save, and let Header fall back
    // via getUserDisplayName. Do not write the string "null" into storage.
    if (res.userName) {
      setUserName(res.userName);
    }

    const decodedPrefs = decodeNotificationPreferences(res.notificationPreferences ?? 0);

    setNotificationPrefs(decodedPrefs);
    setOriginalNotificationPrefs(decodedPrefs);
  }, [executeApi, userId, setProfileImage, setFirstName, setLastName, setUserName]);

  useEffect(() => {
    UserProfileInfo();

    getAccountInfo(userId).then((res) => {
      let displayValue = "";

      if (res.lastPasswordChangedOn) {
        displayValue = new Date(res.lastPasswordChangedOn).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        });
      } else if (res.lastPasswordChangedOnText) {
        displayValue = res.lastPasswordChangedOnText;
      }

      setLastPasswordOn(displayValue);
    });
  }, [permissions, userId, UserProfileInfo]);

  const decodeNotificationPreferences = (value?: number) => ({
    sms: Boolean(value && value & NOTIFICATION_FLAGS.SMS),
    email: Boolean(value && value & NOTIFICATION_FLAGS.EMAIL),
    inApp: Boolean(value && value & NOTIFICATION_FLAGS.IN_APP),
  });

  const [snackbarPassResetMsgOpen, setSnackbarPassResetMsgOpen] = useState<boolean>(false);
  const [snackbarProfileSaveOpen, setSnackbarProfileSaveOpen] = useState<boolean>(false);
  const [snackbarNFOpen, setSnackbarNFOpen] = useState(false);
  const [snackbarNFMessage, setSnackbarNFMessage] = useState("");
  const [snackbarNFSeverity, setSnackbarNFSeverity] = useState<"success" | "error">("success");

  const saveNotifications = async () => {
    let notificationValue = 0;

    if (notificationPrefs.sms) {
      notificationValue |= NOTIFICATION_FLAGS.SMS;
    }
    if (notificationPrefs.email) {
      notificationValue |= NOTIFICATION_FLAGS.EMAIL;
    }
    if (notificationPrefs.inApp) {
      notificationValue |= NOTIFICATION_FLAGS.IN_APP;
    }

    const payload: SaveNFDto = {
      userId: userId,
      notificationPreferences: notificationValue,
    };

    try {
      await executeApi<SaveNFDto, string>(saveNotificationPreferences, payload);

      setSnackbarNFMessage(USERSIGNINMESSAGES.NOTIFICATIONS_SAVED_ALERT);
      setSnackbarNFSeverity("success");
      setSnackbarNFOpen(true);
      setOriginalNotificationPrefs(notificationPrefs);
    } catch (error) {
      setSnackbarNFMessage(USERSIGNINMESSAGES.NOTIFICATION_FAILED_ALERT);
      setSnackbarNFSeverity("error");
      setSnackbarNFOpen(true);
    }
  };

  const onResetPassword = async () => {
    const empAndOtpData: ResetPasswordDto = {
      userId: userId,
      currentPassword: passwordData.password,
      newPassword: passwordData.confirmPassword,
    };
    return await executeApi<ResetPasswordDto, string>(resetPassword, empAndOtpData);
  };
  const verifyAndSave = async () => {
    if (!passwordData.password) {
      setCurrentPasswordError(true);
      currentPasswordRef.current?.focus();
      return;
    }
    // Bug 80058: the current password must be verified before the new one can be submitted.
    if (!isCurrentPasswordVerified) {
      await handleVerifyCurrentPassword();
      return;
    }
    if (!handleChildComponentToValidatePassword()) return;
    handleChangePassword();
  };

  const onPasswordUpdateComplete = (response: boolean) => {
    if (response === true) {
      setSnackbarPassResetMsgOpen(true);
    }
  };

  const handleChangePassword = async () => {
    const status = await onResetPassword();

    // Bug 80058: reset-password now also counts failed current-password attempts, so it can come
    // back locked. Send the user back to the verify step rather than leaving New/Confirm open.
    if (status === SIGNINRESPONSES.ACCOUNT_LOCKED) {
      setIsCurrentPasswordVerified(false);
      setReusePasswordError(USERSIGNINMESSAGES.ACCOUNT_LOCKED_MESSAGE);
      return;
    }

    if (status === PASSWORDCHANGEMODE.NOMATCH_PASSWORD) {
      setIsCurrentPasswordVerified(false);
      setReusePasswordError(USERSIGNINMESSAGES.NOMATCH_PASSWORD_ALERT);

      setTimeout(() => {
        currentPasswordRef.current?.focus();
      }, 0);

      return;
    }

    if (status === PASSWORDCHANGEMODE.CANNOT_REUSE_PASSWORD) {
      setReusePasswordError(USERSIGNINMESSAGES.NEW_PASSWORD_ALERT);
      return;
    }

    onPasswordUpdateComplete(true);
    cancelAccountSettingsChanges();
  };

  const isProfileDirty = formData.username !== originalUserName;
  const isAccountSettingsDirty = passwordData.password !== "" || passwordData.newPassword !== "" || passwordData.confirmPassword !== "";
  const isNotificationsDirty =
    notificationPrefs.sms !== originalNotificationPrefs.sms ||
    notificationPrefs.email !== originalNotificationPrefs.email ||
    notificationPrefs.inApp !== originalNotificationPrefs.inApp;

  return (
    <>
      <BackdropProgressBar loading={loading} />
      <Grid2 container spacing={2} alignItems="stretch">
        <Grid2 size={{ xs: 12, md: 3 }}>
          <Card className="user-image-card">
            <CardContent>
              <Box
                display="flex"
                alignItems="center"
                flexDirection="column"
                mb={2}
                className="user-image-wrap"
              >
                <Box>
                  {/* Hidden File Input */}
                  <input
                    accept="image/*"
                    id="avatar-upload"
                    type="file"
                    className="d-none"
                    ref={avatarUploadRef}
                    onChange={handleFileChange}
                  />

                  {/* Avatar Upload UI */}
                  <label htmlFor="avatar-upload" className="cursor-pointer">
                    <Badge
                      overlap="circular"
                      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                      badgeContent={<CameraAltIcon className="camera-icon" sx={{ boxShadow: 1 }} />}
                    >
                      <Avatar
                        alt="User Avatar"
                        src={imageSrc || undefined}
                        className="custom-avatar"
                      >
                        {!imageSrc &&
                          stringAvatar(formData.firstName, formData.lastName, formData.username)
                            ?.children}
                      </Avatar>
                    </Badge>
                  </label>

                  {/* Remove Photo - deliberately outside the <label>, which would otherwise
                      re-open the file picker on click (Bug 79975). */}
                  {imageSrc && (
                    <Box textAlign="center" mt={1}>
                      <Button
                        size="small"
                        variant="text"
                        startIcon={<DeleteOutlineIcon fontSize="small" />}
                        onClick={() => setRemovePhotoConfirmOpen(true)}
                      >
                        {USER_PROFILE_TEXT.PROFILE_PHOTO.REMOVE_LABEL}
                      </Button>
                    </Box>
                  )}

                  <ConfirmationDialog
                    open={removePhotoConfirmOpen}
                    title={USER_PROFILE_TEXT.PROFILE_PHOTO.REMOVE_CONFIRM_TITLE}
                    message={USER_PROFILE_TEXT.PROFILE_PHOTO.REMOVE_CONFIRM_MESSAGE}
                    onClose={handleRemovePhotoConfirm}
                  />

                  {/* Cropper Dialog */}
                  <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
                    <DialogContent className="dialog-content">
                      <Cropper
                        image={selectedImage}
                        crop={crop}
                        zoom={zoom}
                        aspect={1}
                        onCropChange={setCrop}
                        onZoomChange={setZoom}
                        onCropComplete={onCropComplete}
                      />
                    </DialogContent>
                    <Box px={3} py={2} className="d-flex gap-3 align-items-center">
                      {/* <Typography gutterBottom>Zoom</Typography> */}
                      <ImageIcon fontSize="small" color="disabled" />
                      <Slider
                        value={zoom}
                        min={1}
                        max={3}
                        step={0.1}
                        size="small"
                        onChange={(e, value) =>
                          setZoom(typeof value === "number" ? value : value[0])
                        }
                      />
                      <ImageIcon color="disabled" />
                    </Box>
                    <Divider></Divider>
                    <DialogActions className="d-flex justify-content-center">
                      <Button onClick={() => setOpen(false)} size="small" variant="outlined">
                        Cancel
                      </Button>
                      <Button variant="contained" size="small" onClick={handleCropSave}>
                        <CropIcon fontSize="small" />
                        Crop & Save
                      </Button>
                    </DialogActions>
                  </Dialog>
                </Box>
                <Box textAlign="center" mt={1}>
                  <Typography variant="h5">
                    {`${formData.firstName} ${formData.lastName}`.trim() ||
                      formData.username ||
                      `${firstName ?? ""} ${lastName ?? ""}`.trim()}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {rolesList.join(", ")}
                  </Typography>
                </Box>
              </Box>

              <Box className="navigation-tabs">
                <Tabs
                  value={value}
                  onChange={handleChange}
                  aria-label="basic tabs example"
                  orientation="vertical"
                  className="custom-tabs"
                >
                  <Tab
                    icon={<AccountCircleTwoToneIcon />}
                    iconPosition="start"
                    label="Personal Info"
                    {...a11yProps(0)}
                    className="custom-tab"
                  />
                  <Tab
                    icon={<SettingsTwoToneIcon />}
                    iconPosition="start"
                    label="Account Settings"
                    {...a11yProps(1)}
                    className="custom-tab"
                  />
                  <Tab
                    icon={<NotificationsNoneTwoToneIcon />}
                    iconPosition="start"
                    label="Notifications"
                    {...a11yProps(2)}
                    className="custom-tab"
                  />
                </Tabs>
              </Box>
            </CardContent>
          </Card>
        </Grid2>

        <Grid2 size={{ xs: 12, md: 9 }}>
          <Card className="tabs-content">
            <Box className="w-100">
              <CustomTabPanel value={value} index={0}>
                <CardHeader
                  className="tabs-content-title"
                  title={
                    <Box display="flex" alignItems="center" gap={1}>
                      <AccountCircleTwoToneIcon color="primary" />
                      <Typography variant="h5" component="div" className="title-typography">
                        Personal Info
                      </Typography>
                    </Box>
                  }
                />
                <CardContent>
                  <Grid2 container spacing={1} className="mt-2">
                    {/* Username */}
                    <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                      <TextField
                        label="Username"
                        fullWidth
                        value={formData.username}
                        onChange={handleUserNameChange}
                        onBlur={handleUserNameBlur}
                        size="small"
                        margin="normal"
                        error={userNameError}
                        helperText={userNameErrorMessage}
                        color={userNameError ? "error" : "primary"}
                      />
                    </Grid2>

                    {/* Email (Disabled unless user has permission) */}
                    <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                      <TextField
                        label="Email"
                        fullWidth
                        value={formData.email}
                        disabled={!hasEmailEditPermission}
                        onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                        size="small"
                        margin="normal"
                      />
                    </Grid2>

                    {/* Phone (Disabled unless user has permission) */}
                    <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                      <TextField
                        label="Phone"
                        fullWidth
                        size="small"
                        disabled={!hasPhoneEditPermission}
                        value={formData.phone}
                        onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                        margin="normal"
                      />
                    </Grid2>

                    {/* First Name */}
                    <Grid2 size={{ xs: 12, sm: 4 }}>
                      <TextField
                        label="First Name"
                        fullWidth
                        value={formData.firstName}
                        disabled={!hasFirstNameEditPermission}
                        onChange={(e) => setFormData({ ...formData, firstName: e.target.value })}
                        size="small"
                        margin="normal"
                      />
                    </Grid2>

                    {/* Last Name */}
                    <Grid2 size={{ xs: 12, sm: 4 }}>
                      <TextField
                        label="Last Name"
                        fullWidth
                        value={formData.lastName}
                        disabled={!hasLastNameEditPermission}
                        onChange={(e) => setFormData({ ...formData, lastName: e.target.value })}
                        size="small"
                        margin="normal"
                      />
                    </Grid2>

                    {/* Active Until Date (Disabled unless permission) */}
                    <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          label="Active Until"
                          disabled={!hasActiveUntilPermission}
                          value={toDisplayDateOrNull(formData.activeUntil)}
                          onChange={(newValue) => {
                            setFormData({
                              ...formData,
                              activeUntil: newValue
                                ? newValue.toISOString().split("T")[0] // yyyy-mm-dd
                                : "",
                            });
                          }}
                          slotProps={{
                            textField: {
                              fullWidth: true,
                              size: "small",
                              margin: "normal",
                              inputProps: { readOnly: true }, // optional, matches your other datepicker
                            },
                          }}
                        />
                      </LocalizationProvider>
                    </Grid2>

                    {/* Roles (Comma-separated from API) */}
                    <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                      <TextField
                        label="Roles"
                        fullWidth
                        size="small"
                        value={rolesList.join(", ")}
                        disabled={!hasRoleEditPermission}
                        margin="normal"
                      />
                    </Grid2>
                  </Grid2>
                </CardContent>
                <Box display="flex" justifyContent="flex-end" gap={2} mt={2} px={3} pb={2}>
                  <Button
                    variant="contained"
                    size="small"
                    disabled={!isProfileDirty}
                    onClick={savePersonalInfo}
                  >
                    Save
                  </Button>
                  <Button variant="outlined" size="small" disabled={!isProfileDirty} onClick={cancelPersonalInfoChanges}>
                    Cancel
                  </Button>
                </Box>
              </CustomTabPanel>
              <CustomTabPanel value={value} index={1}>
                <CardHeader
                  className="tabs-content-title"
                  title={
                    <Box display="flex" alignItems="center" gap={1}>
                      <SettingsTwoToneIcon color="primary" />
                      <Typography variant="h5" component="div" className="title-typography">
                        Account Settings
                      </Typography>
                    </Box>
                  }
                />
                <Grid2 container spacing={2} className="m-3">
                  <Grid2 size={{ xs: 12, xl: 7 }}>
                    <Card variant="outlined">
                      <CardContent>
                        {/* change password section */}

                        <Box>
                          <Typography className="group-title">Last Password Changed on</Typography>

                          <Box mb={2}>
                            <TextField
                              fullWidth
                              label=""
                              variant="outlined"
                              size="small"
                              value={lastPasswordOn}
                              placeholder="LastPasswordOn"
                              disabled
                              slotProps={{
                                input: {
                                  readOnly: true,
                                },
                              }}
                            />
                          </Box>
                          <Typography className="group-title">Current Password</Typography>

                          <Box mb={2} display="flex" alignItems="flex-start" gap={1}>
                            <TextField
                              fullWidth
                              type="password"
                              label="Current Password"
                              value={passwordData.password}
                              variant="outlined"
                              size="small"
                              placeholder="Current Password"
                              onChange={handleOldPasswordChange}
                              inputRef={currentPasswordRef}
                              error={currentPasswordError}
                              helperText={currentPasswordError ? "Current Password is required" : ""}
                              disabled={isCurrentPasswordVerified}
                            />
                            {!isCurrentPasswordVerified && (
                              <Button
                                variant="contained"
                                size="small"
                                onClick={handleVerifyCurrentPassword}
                                disabled={!passwordData.password}
                              >
                                Verify
                              </Button>
                            )}
                          </Box>
                          {isCurrentPasswordVerified && (
                            <Box mb={2} className="reset-password">
                              <PasswordComponent
                                ref={passwordRef}
                                onPasswordInputChange={handlePasswordChange}
                                onConfirmPasswordInputChange={handleConfirmPasswordChange}
                                userFirstName={""}
                                userLastName={""}
                                userName={""}
                                title="Reset Your Password"
                              />
                            </Box>
                          )}
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid2>
                </Grid2>
                <Box display="flex" justifyContent="flex-end" gap={2} mt={2} px={3} pb={2}>
                  <Button variant="contained" size="small" onClick={saveAccountSettings} disabled={!isAccountSettingsDirty}>
                    Save Password
                  </Button>
                  <Button variant="outlined" size="small" onClick={cancelAccountSettingsChanges} disabled={!isAccountSettingsDirty}>
                    Cancel
                  </Button>
                </Box>
              </CustomTabPanel>

              <CustomTabPanel value={value} index={2}>
                <CardHeader
                  className="tabs-content-title"
                  title={
                    <Box display="flex" alignItems="center" gap={1}>
                      <NotificationsNoneTwoToneIcon color="primary" />
                      <Typography variant="h5" component="div" className="title-typography">
                        {USER_PROFILE_TEXT.NOTIFICATION_TAB.TITLE}
                      </Typography>
                    </Box>
                  }
                />
                <Box className="m-3">
                  <Paper variant="outlined" className="custom-paper">
                    <Grid2 container spacing={3}>
                      <Grid2 size={{ xs: 12, md: 5 }}>
                        <Typography fontSize={16} fontWeight="600" mb={0.5}>
                          {USER_PROFILE_TEXT.NOTIFICATION_TAB.PREF_TITLE}
                        </Typography>
                        <Typography fontSize={12} color="text.secondary">
                          {USER_PROFILE_TEXT.NOTIFICATION_TAB.PREF_DESC}
                        </Typography>
                      </Grid2>
                      <Grid2 size={{ xs: 12, md: 7 }}>
                        {renderSwitchRow(
                          USER_PROFILE_TEXT.NOTIFICATIONS.SMS.LABEL,
                          USER_PROFILE_TEXT.NOTIFICATIONS.SMS.DESC,
                          notificationPrefs.sms,
                          (checked) => setNotificationPrefs((prev) => ({ ...prev, sms: checked })),
                        )}

                        {renderSwitchRow(
                          USER_PROFILE_TEXT.NOTIFICATIONS.NEW_MAILS.LABEL,
                          USER_PROFILE_TEXT.NOTIFICATIONS.NEW_MAILS.DESC,
                          notificationPrefs.email,
                          (checked) =>
                            setNotificationPrefs((prev) => ({ ...prev, email: checked })),
                        )}

                        {renderSwitchRow(
                          USER_PROFILE_TEXT.NOTIFICATIONS.IN_APP.LABEL,
                          USER_PROFILE_TEXT.NOTIFICATIONS.IN_APP.DESC,
                          notificationPrefs.inApp,
                          (checked) =>
                            setNotificationPrefs((prev) => ({ ...prev, inApp: checked })),
                        )}
                      </Grid2>
                    </Grid2>
                  </Paper>
                </Box>
                <Box display="flex" justifyContent="flex-end" gap={2} mt={2} px={3} pb={2}>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={saveNotifications}
                    disabled={!isNotificationsDirty}
                  >
                    Save Preferences
                  </Button>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={cancelNotificationChanges}
                    disabled={!isNotificationsDirty}
                  >
                    Cancel
                  </Button>
                </Box>
              </CustomTabPanel>

              <Divider></Divider>
            </Box>
          </Card>
        </Grid2>
      </Grid2>
      <>
        <Snackbar
          open={!!reusePasswordError}
          autoHideDuration={5000}
          onClose={() => setReusePasswordError(null)}
          TransitionComponent={SlideUp}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert severity="error" variant="filled">
            {reusePasswordError}
          </Alert>
        </Snackbar>
        <Snackbar
          open={snackbarProfileSaveOpen}
          autoHideDuration={5000}
          onClose={handleProfileSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert onClose={handleProfileSnackbarClose} severity="success">
            {USERSIGNINMESSAGES.PROFILE_UPDATE_SUCCESS}
          </Alert>
        </Snackbar>
        <Snackbar
          open={snackbarPhotoRemovedOpen}
          autoHideDuration={5000}
          onClose={() => setSnackbarPhotoRemovedOpen(false)}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert onClose={() => setSnackbarPhotoRemovedOpen(false)} severity="success">
            {USER_PROFILE_TEXT.PROFILE_PHOTO.REMOVE_SUCCESS}
          </Alert>
        </Snackbar>
        <Snackbar
          open={snackbarNFOpen}
          autoHideDuration={4000}
          onClose={() => setSnackbarNFOpen(false)}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert
            onClose={() => setSnackbarNFOpen(false)}
            severity={snackbarNFSeverity}
            sx={{ width: "100%" }}
          >
            {snackbarNFMessage}
          </Alert>
        </Snackbar>

        <Snackbar
          open={snackbarPassResetMsgOpen}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          autoHideDuration={15000}
          onClose={handleSnackbarClose}
        >
          <Alert severity="success">{USERSIGNINMESSAGES.PASSWORD_RESET_MESSAGE}</Alert>
        </Snackbar>

        {/* rest of your JSX */}
      </>
    </>
  );
}
